module.exports = __webpack_public_path__ + "img/banner_blenche.3693ab76.png";